query availableCampaigns($companyId: ID!) {
  availableCampaigns(companyId: $companyId) {
    id
    name
    slug
    isActive
    type
    landingpages {
      country
      landingpageSlug
    }
  }
}
